import { getOrganization } from "../Resources/Organization/OrganizationData.js"
import DataEnrichmentApi from './DataEnrichmentApi.js'
import { createSelector } from 'reselect'
import { receivedServerData } from "../components/Common/Data/DataFetcher.js";
import { identifyWithDataSources, GOOGLE_PLACES_DATA_SOURCE, CLEARBIT_DATA_SOURCE } from "../components/Services/Analytics/IdentifyPropertiesService.js"
import { getProFromDataEnrichment } from './DataEnrichmentProData.js'
import { EmptyObject } from "../Resources/EmptyDefaults";
import { isPresent } from "utils/isPresent";
import { isBlank } from "utils/isBlank";

export const DATA_ENRICHMENT_ORG_FROM_SERVER_NAMESPACE = 'dataEnrichmentOrgFromServer'

export const DATA_ENRICHMENT_ORG_FROM_GOOGLE_NAMESPACE = 'dataEnrichmentOrgFromGoogle'

export const SOURCE_GOOGLE_MY_BUSINESS = 'Google My Business'

export const GOOGLE_ICON = 'googleIcon'

export const CLEARBIT_ICON = 'clearbitIcon'

export const getOrgFromGooglePlaces = (state) => state.dataEnrichmentOrgFromGoogle || {}

export const getOrganizationFromServer = createSelector(
    (state) => state.dataEnrichmentOrgFromServer,
    (organization) => {
        return organization || EmptyObject
    }
)

export const getOrgInfo = (info) => createSelector(
    getOrganization,
    getOrgFromGooglePlaces,
    getOrganizationFromServer,
    (organization, orgFromGooglePlaces, orgFromServer) => {
        return organization[info] || orgFromGooglePlaces[info] || orgFromServer[info] || ""
    }
)

export const getBusinessName = getOrgInfo('company_name')
export const getBusinessPhone = getOrgInfo('phone_number')
export const getBusinessWebsite = getOrgInfo('company_website')
export const getStreet = getOrgInfo('street')
export const getUnit = getOrgInfo('street_line_2')
export const getCity = getOrgInfo('city')
export const getState = getOrgInfo('state')
export const getZip = getOrgInfo('zip')
export const getCountry = getOrgInfo('country')
export const getLat = getOrgInfo('latitude')
export const getLong = getOrgInfo('longitude')
export const getSource = getOrgInfo('source')

export const getAddress = createSelector(
    getOrganization,
    getOrgFromGooglePlaces,
    getOrganizationFromServer,
    (organization, orgFromGooglePlaces, orgFromServer) => {
        return formatAddress(organization) || formatAddress(orgFromGooglePlaces) || formatAddress(orgFromServer) || ""
    }
)

export const showDataAppendIcon = (info) => createSelector(
    getOrganization,
    getOrgFromGooglePlaces,
    getOrganizationFromServer,
    getSource,
    (organization, orgFromGooglePlaces, orgFromServer, source) => {
        if (isPresent(orgFromGooglePlaces[info]) && isBlank(organization[info])) {
            return GOOGLE_ICON
        } else if (isPresent(orgFromServer[info]) && isBlank(organization[info])) {
            return source == SOURCE_GOOGLE_MY_BUSINESS ? GOOGLE_ICON : CLEARBIT_ICON
        } else {
            return null
        }
    }
)

export const showDataAppendForBusinessWebsite = showDataAppendIcon('company_website')
export const showDataAppendForBusinessName = showDataAppendIcon('company_name')
export const showDataAppendForBusinessPhone = showDataAppendIcon('phone_number')

export const showDataAppendForAddress = createSelector(
    getOrganization,
    getOrgFromGooglePlaces,
    getOrganizationFromServer,
    getSource,
    (org, orgFromGooglePlaces, orgFromServer, source) => {
        if (isPresent(formatAddress(orgFromGooglePlaces)) && isBlank(formatAddress(org))) {
            return GOOGLE_ICON
        } else if (isPresent(formatAddress(orgFromServer)) && isBlank(formatAddress(org))) {
          return source == SOURCE_GOOGLE_MY_BUSINESS ? GOOGLE_ICON : CLEARBIT_ICON
        } else {
            return null
        }
    }
)

function formatAddress(organization) {
    const street_2 = isPresent(organization.street_line_2) ? (organization.street_line_2 + ", ") : ""
    if (isPresent(organization.street)) {
        return `${organization.street}, ${street_2}${organization.city}, ${organization.state}, ${organization.zip}, ${organization.country}`
    } else {
        return null
    }
}

export const fetchOrganizationFromDataEnrichment = {
    fetchingApiFunc: DataEnrichmentApi.fetchOrganizationFromDataEnrichment,
    selector: getOrganizationFromServer,
    paramsFromProps: () => [],
    dataNamespace: DATA_ENRICHMENT_ORG_FROM_SERVER_NAMESPACE
}

export function receivedGooglePlacesData(data) {
    return (dispatch, getState) => {
        const formattedData = { street: data.street,
                                city: data.city,
                                state: data.state,
                                zip: data.postal_code,
                                country: data.country,
                                longitude: data.longitude,
                                latitude: data.latitude,
                                company_name: data.name,
                                phone_number: data.formatted_phone_number,
                                company_website: data.website }
        dispatch(receivedServerData(formattedData, DATA_ENRICHMENT_ORG_FROM_GOOGLE_NAMESPACE))

        const dataSources = [GOOGLE_PLACES_DATA_SOURCE]
        if (hasClearbitData(getState)) {
            dataSources.push(CLEARBIT_DATA_SOURCE)
        }
        dispatch(identifyWithDataSources(dataSources))
    }
}

function hasClearbitData(getState) {
    const orgData = getOrganizationFromServer(getState())
    const proData = getProFromDataEnrichment(getState())
    return Object.values(orgData).some(x => isPresent(x)) || Object.values(proData).some(x => isPresent(x))
}
